import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Pencil, Check, X, Plus, Trash } from 'lucide-react';

const AchievementsSection = ({ achievements, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedAchievements, setEditedAchievements] = useState(achievements);

  const handleAddAchievement = () => {
    setEditedAchievements([...editedAchievements, {
      id: Date.now(),
      title: '',
      issuer: '',
      date: ''
    }]);
  };

  const handleRemoveAchievement = (id) => {
    setEditedAchievements(editedAchievements.filter(item => item.id !== id));
  };

  const handleChange = (id, field, value) => {
    setEditedAchievements(editedAchievements.map(item =>
      item.id === id ? { ...item, [field]: value } : item
    ));
  };

  const handleSave = () => {
    onUpdate(editedAchievements);
    setIsEditing(false);
  };

  return (
    <div className="profile-section">
      <div className="flex justify-between items-center mb-4">
        <h2 className="section-title">Achievements</h2>
        {!isEditing ? (
          <Button variant="ghost" size="sm" onClick={() => setIsEditing(true)}
            className="text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white">
            <Pencil className="w-4 h-4" />
          </Button>
        ) : (
          <div className="flex gap-2">
            <Button variant="ghost" size="sm" onClick={() => setIsEditing(false)}>
              <X className="w-4 h-4" />
            </Button>
            <Button variant="ghost" size="sm" onClick={handleSave}>
              <Check className="w-4 h-4" />
            </Button>
          </div>
        )}
      </div>

      <div className="space-y-4">
        {(isEditing ? editedAchievements : achievements).map((achievement) => (
          <div key={achievement.id} className="achievement-item">
            {isEditing ? (
              <div className="flex flex-col gap-2 w-full">
                <Input
                  value={achievement.title}
                  onChange={(e) => handleChange(achievement.id, 'title', e.target.value)}
                  placeholder="Achievement title"
                />
                <div className="flex gap-2">
                  <Input
                    value={achievement.issuer}
                    onChange={(e) => handleChange(achievement.id, 'issuer', e.target.value)}
                    placeholder="Issuer"
                  />
                  <Input
                    value={achievement.date}
                    onChange={(e) => handleChange(achievement.id, 'date', e.target.value)}
                    placeholder="Date"
                  />
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => handleRemoveAchievement(achievement.id)}
                    className="text-red-500"
                  >
                    <Trash className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            ) : (
              <div className="flex items-start gap-4">
                {achievement.icon && <achievement.icon className="w-6 h-6 text-blue-600 dark:text-blue-400" />}
                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white">{achievement.title}</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {achievement.issuer} • {achievement.date}
                  </p>
                </div>
              </div>
            )}
          </div>
        ))}
        {isEditing && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleAddAchievement}
            className="w-full"
          >
            <Plus className="w-4 h-4 mr-2" /> Add Achievement
          </Button>
        )}
      </div>
    </div>
  );
};

export default AchievementsSection;
